// import React, { useState, useEffect, useRef } from "react";
// import "./selector.css";
// import dropnewicon from "../../../assets/img/dropnewicon.svg";

// const Selector = ({
//   label,
//   options,
//   name,
//   value,
//   onChange,
//   LabelFontSize,
//   SelectorFontSize,
//   labelColor = "#2C357D80",
//   starColor = "red",
//   showStar,
//   error,
//   width,
//   borderColor,
//   disabled,
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const wrapperRef = useRef(null);

//   const handleToggleDropdown = () => {
//     if (!disabled) {
//       setIsOpen(!isOpen);
//     }
//   };

//   const handleOptionClick = (optionValue) => {
//     if (!disabled && !optionValue.isDisabled) {
//       onChange({ target: { name, value: optionValue.value } });
//       setIsOpen(false);
//     }
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const labelStyle = {
//     fontSize: LabelFontSize,
//     color: labelColor,
//   };

//   const selectStyle = {
//     fontSize: SelectorFontSize,
//     borderBottom: `1px solid ${borderColor}`,
//     backgroundColor: disabled ? "" : "white",
//     cursor: disabled ? "not-allowed" : "pointer",
//   };

//   const handleClearSelection = (e) => {
//     e.stopPropagation();
//     if (!disabled) {
//       onChange({ target: { name, value: "" } });
//     }
//   };

//   return (
//     <div
//       className="selector_wrapper"
//       style={{ width: width || "100%" }}
//       ref={wrapperRef}
//     >
//       <label className="selector_label" style={labelStyle}>
//         {label} {showStar && <span style={{ color: starColor }}> *</span>}
//       </label>
//       <div
//         className={`custom_selector ${disabled ? "disabled" : ""}`}
//         style={selectStyle}
//         onClick={handleToggleDropdown}
//       >
//         {value
//           ? options?.find((option) => option?.value === value)?.label
//           : "Select an option"}

//         <div>
//           {value && (
//             <svg
//               width="25"
//               height="30"
//               viewBox="0 0 60 60"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//               onClick={handleClearSelection}
//               style={{ cursor: disabled ? "not-allowed" : "pointer" }}
//             >
//               <rect
//                 width="60"
//                 height="60"
//                 rx="30"
//                 fill="#2C357D"
//                 fillOpacity="0.15"
//               />
//               <path
//                 d="M37.75 22.1377L21.25 38.6377"
//                 stroke="#2C357D"
//                 strokeWidth="3"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//               <path
//                 d="M21.25 22.1377L37.75 38.6377"
//                 stroke="#2C357D"
//                 strokeWidth="3"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//           )}

//           {!disabled && (
//             <img
//               src={dropnewicon}
//               alt=""
//               className={`dropdown_icon ${isOpen ? "open" : ""}`}
//             />
//           )}
//         </div>
//       </div>
//       {isOpen && !disabled && (
//         <div className="custom_dropdown">
//           {options?.map((option) => (
//             <div
//               key={option.value}
//               className={`custom_option ${
//                 option.isDisabled ? "disabled_option" : ""
//               }`}
//               onClick={() => handleOptionClick(option)}
//               style={{
//                 cursor:
//                   option.isDisabled || disabled ? "not-allowed" : "pointer",
//               }}
//             >
//               {option.label}
//             </div>
//           ))}
//         </div>
//       )}
//       {error && <div className="error">{error}</div>}
//     </div>
//   );
// };

// export default Selector;

import React, { useState, useEffect, useRef } from "react";
import "./selector.css";
import dropnewicon from "../../../assets/img/dropnewicon.svg";

const Selector = ({
  label,
  options,
  name,
  value,
  onChange,
  LabelFontSize,
  SelectorFontSize,
  labelColor = "#2C357D80",
  starColor = "red",
  showStar,
  error,
  width,
  borderColor,
  disabled,
  search = false,
  dropdownHeight = "200px", // New prop for dropdown height
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options); // State for filtered options
  const wrapperRef = useRef(null);

  // Handle dropdown toggle
  const handleToggleDropdown = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
      setSearchTerm(""); // Reset search when opening/closing
    }
  };

  // Handle option selection
  const handleOptionClick = (optionValue) => {
    if (!disabled && !optionValue.isDisabled) {
      onChange({ target: { name, value: optionValue.value } });
      setIsOpen(false);
      setSearchTerm("");
    }
  };

  // Click outside handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Filter options when searchTerm or options change
  useEffect(() => {
    if (search) {
      const filtered = options?.filter((option) =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredOptions(filtered);
    } else {
      setFilteredOptions(options); // No filtering when search is false
    }
  }, [search, searchTerm, options]);

  const labelStyle = {
    fontSize: LabelFontSize,
    color: labelColor,
  };

  const selectStyle = {
    fontSize: SelectorFontSize,
    borderBottom: `1px solid ${borderColor}`,
    backgroundColor: disabled ? "" : "white",
    cursor: disabled ? "not-allowed" : "pointer",
  };

  const handleClearSelection = (e) => {
    e.stopPropagation();
    if (!disabled) {
      onChange({ target: { name, value: "" } });
      setSearchTerm("");
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Prevent closing when clicking inside the dropdown
  const handleDropdownClick = (e) => {
    e.stopPropagation();
  };

  // Handle backspace to clear selection
  const handleKeyDown = (e) => {
    if (e.key === "Backspace" && value && !searchTerm && !disabled) {
      e.preventDefault();
      onChange({ target: { name, value: "" } });
      setSearchTerm("");
    }
    if (e.key === "Escape" && isOpen) {
      setIsOpen(false);
      setSearchTerm("");
    }
  };

  return (
    <div
      className="selector_wrapper"
      style={{ width: width || "100%" }}
      ref={wrapperRef}
    >
      <label className="selector_label" style={labelStyle}>
        {label} {showStar && <span style={{ color: starColor }}> *</span>}
      </label>
      <div
        className={`custom_selector ${disabled ? "disabled" : ""}`}
        style={selectStyle}
        onClick={handleToggleDropdown}
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
        {value
          ? options?.find((option) => option?.value === value)?.label
          : "Select an option"}

        <div>
          {value && (
            <svg
              width="25"
              height="30"
              viewBox="0 0 60 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={handleClearSelection}
              style={{ cursor: disabled ? "not-allowed" : "pointer" }}
            >
              <rect
                width="60"
                height="60"
                rx="30"
                fill="#2C357D"
                fillOpacity="0.15"
              />
              <path
                d="M37.75 22.1377L21.25 38.6377"
                stroke="#2C357D"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21.25 22.1377L37.75 38.6377"
                stroke="#2C357D"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}

          {!disabled && (
            <img
              src={dropnewicon}
              alt=""
              className={`dropdown_icon ${isOpen ? "open" : ""}`}
            />
          )}
        </div>
      </div>
      {isOpen && !disabled && (
        <div
          className="custom_dropdown"
          style={{ maxHeight: dropdownHeight }}
          onClick={handleDropdownClick}
        >
          {search && (
            <div className="search_container">
              <input
                type="text"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Search options..."
                className="search_input"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          )}
          {filteredOptions?.map((option) => (
            <div
              key={option.value}
              className={`custom_option ${
                option.isDisabled ? "disabled_option" : ""
              }`}
              onClick={() => handleOptionClick(option)}
              style={{
                cursor:
                  option.isDisabled || disabled ? "not-allowed" : "pointer",
              }}
            >
              {option.label}
            </div>
          ))}
          {search && filteredOptions?.length === 0 && (
            <div className="no_options">No options found</div>
          )}
        </div>
      )}
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default Selector;
